import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { media } from 'style-utils';
import { bindActionCreators } from 'redux';
import { NitroButton } from 'nitro-components';
import Tabs from '../../components/common/tabs';
import EmbedDisplay from '../powerbi/EmbedDisplay';
import { getHeaderMenu } from '../../layouts/selector';

import {
  CostcenterFilter,
  CountryFilter,
  FilterGroup
} from '../../components/filter';
import { getInsightsCCAndCountry } from '../powerbi/selector';
import { updateCurrentRole } from '../../components/common/Profile/utils';
import * as routes from '../../routes/const';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../components/common/Profile/selector';
import {
  setGlobalCountryCostCenter,
  setGlobalDynamicFilter
} from '../../action/CommonActions';
import { changeCurrentRole } from '../../auth/actions';
import constants from '../../constants';

const { C_TRACK_ENDPOINT } = constants;

const Main = styled.div`
  display: flex;
  flex-grow: 1;
  position: relative;
  flex-direction: column;
  overflow: auto;
`;

const NavContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.color.white};
  border-bottom: solid 1px ${props => props.theme.color.iceBlue};
  width: 100vw;
  position: fixed;
  z-index: 1;

  /* Required as this element is fixed and can not inherit widths / height from its relative parent */
  ${media.desktop`
    width: calc(100vw - 60px);
  `}
`;

const Breadcrumbs = styled.div`
  padding: 8px 16px;
  border-top: solid 1px ${props => props.theme.color.iceBlue};
  border-bottom: solid 1px ${props => props.theme.color.iceBlue};
  font-size: 11px;
  letter-spacing: 0.4px;
`;

const Breadcrumb = styled.span`
  color: ${props => props.theme.color.primary};
  text-transform: uppercase;
  cursor: pointer;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 36px;

  & .button-content {
    background: #28b277;
    border-color: #28b277;

    &:hover {
      background: #28b277dd;
      border-color: #28b277dd;
    }
  }
`;

const Title = styled.h6`
  font-family: ${props => props.theme.font.bold};
  color: ${props => props.theme.color.grey9};
  font-size: 18px;
  letter-spacing: 0.2px;
  margin: 0;
`;

const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 36px;

  & > div:first-child > div {
    color: #28b277;
    background: #28b27705;
    transition: color 0.3s ease, background-color 0.3s ease;

    &::after {
      background: #28b277;
    }

    &:hover {
      color: #28b277;
      background: #28b2771a;
    }
  }
`;

const FilterContainer = styled.div`
  position: relative;
  display: flex;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 144px 0 0;
  flex-grow: 1;
  display: flex;

  ${media.mobileTablet`
    padding: 148px 0 0;
  `}
`;

function getActiveTab(tabs, key) {
  return tabs.find(tab => tab.id === key) || {};
}

class AccidentManagement extends Component {
  constructor(props, context) {
    super(props, context);

    const activeMenu = this.getActiveMenu(this.props.menus);
    let tabs = [];
    if (activeMenu) {
      const metadata = JSON.parse(activeMenu.metadata);
      tabs = metadata.tabs || [];
    }

    this.state = { tabs };

    this.changeTab = this.changeTab.bind(this);
    this.goHome = this.goHome.bind(this);
  }

  setSource = filters => {
    const country = filters[0];
    const costcenter = filters[1];
    this.props.setGlobalCountryCostCenter({ country, costcenter });
    if (this.props.role.country !== country.value) {
      updateCurrentRole(
        this.props.roles,
        [],
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(routes.INSIGHTS);
        }
      );
    }
  };

  getActiveMenu(menus) {
    for (let i = 0; i < menus.length; i += 1) {
      const activeMenu = this.isActiveMenu(menus[i]);
      if (activeMenu) {
        return activeMenu;
      }
    }
    return null;
  }

  isActiveMenu(menu) {
    const { path } = this.props.params;
    if (menu.route && menu.route.includes(path)) {
      return menu;
    } else if (menu.children.length) {
      return this.getActiveMenu(menu.children);
    }
    return null;
  }

  changeTab(tab) {
    this.context.router.push(tab.route);
  }

  goHome() {
    this.context.router.push(this.props.homeRoute);
  }

  render() {
    const { country, costcenter, params } = this.props;
    const { path } = params;
    const { tabs } = this.state;
    const activeTab = getActiveTab(tabs, path);

    const source = [
      {
        title: 'Country',
        label: country.label,
        value: country.value,
        component: CountryFilter
      },
      {
        title: 'Cost Centre',
        value: costcenter.value,
        label: costcenter.label,
        component: CostcenterFilter
      }
    ];

    return (
      <Main>
        <NavContainer>
          <Breadcrumbs>
            <Breadcrumb onClick={this.goHome}>Home</Breadcrumb>
            <span> / TELEMATICS</span>
          </Breadcrumbs>
          <Header>
            <Title>Telematics</Title>
            <NitroButton
              action={() => (window.location.href = C_TRACK_ENDPOINT)}
              size="extraSmall"
              label="C-TRACK"
              variant="primary"
            />
          </Header>
          <TabsContainer>
            <Tabs activeKey={path} tabs={tabs} onClick={this.changeTab} />
            <FilterContainer>
              <FilterGroup
                width="100%"
                flat
                action={this.setSource}
                title="Source"
                icon="source"
                filters={source}
                align="right"
              />
            </FilterContainer>
          </TabsContainer>
        </NavContainer>
        <Container>
          <EmbedDisplay
            params={{ id: activeTab.contentId }}
            hideBackNav
            hideFilter
            height="100%"
            width="100%"
            location={this.props.location}
          />
        </Container>
      </Main>
    );
  }
}

AccidentManagement.contextTypes = {
  router: PropTypes.shape({})
};

AccidentManagement.defaultProps = {
  homeRoute: '/',
  menus: []
};

AccidentManagement.propTypes = {
  // The route to direct to when selecting home
  homeRoute: PropTypes.string,

  // A list of application menus used to determine tabs on this page
  menus: PropTypes.arrayOf(PropTypes.object)
};

const mapStateToProps = state => {
  const { costcenter, country } = getInsightsCCAndCountry(state);

  return {
    country,
    costcenter,
    role: getCurrentRole(state),
    roles: getFormatedRoles(state),
    homeRoute: state.auth.config.homeRoute,
    menus: getHeaderMenu(state)
  };
};

const mapDispatchToProps = dispatch => ({
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AccidentManagement);



// WEBPACK FOOTER //
// ./src/features/telematics/index.js